export default __webpack_public_path__ + "static/media/start-pin.9dcc578a.svg";